var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWatreCap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M504.565 3H8V328.174M504.565 3V328.174H8M504.565 3L521 19.4348V344.608H24.4348L8 328.174",
    stroke: "#3E68FF",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 328.174L24.5 344.608H521L504.565 328.174H8.5Z",
    fill: "#183AB3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M521 344.608V19.4348L504.565 3V328.174L521 344.608Z",
    fill: "#3E68FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 368V345H521.426V0H544.5V368H0Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.064 73.4373L206.843 166.639C184.591 219.237 225.628 257.673 259.441 258.251C294.121 260.274 341.804 232.53 322.153 169.528C293.253 120.11 264.064 73.4373 264.064 73.4373ZM233.982 180.53L263.689 132.143C263.689 132.143 278.843 156.374 293.846 182.03C304.048 214.738 279.293 229.142 261.288 228.092C243.734 227.792 222.429 207.836 233.982 180.53Z",
    fill: "#3E68FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M263.465 151.484L243.188 184.511C235.303 203.15 249.845 216.77 261.827 216.975C274.116 217.691 291.013 207.86 284.049 185.535C273.809 168.024 263.465 151.484 263.465 151.484Z",
    fill: "#3E68FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatreCap);
export default __webpack_public_path__ + "static/media/watre-cap.c9a45c99928ba812c4649b78fcf6fa27.svg";
export { ForwardRef as ReactComponent };